import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import GroupDetailInfoSkeleton from '@components/Group/Skeleton/GroupDetailInfoSkeleton';
import GroupInvestSummarySkeleton from '@components/Group/Skeleton/GroupInvestSummarySkeleton';
// import GroupPerformanceSkeleton from '@components/Group/Skeleton/GroupPerformanceSkeleton';
import PortfolioListSkeleton from '@components/Group/Skeleton/PortfolioListSkeleton';

const GroupDetailInfo = lazy(() => import('@components/Group/GroupDetailInfo'));
const GroupInvestSummary = lazy(
  () => import('@components/Group/GroupInvestSummary')
);
// const GroupPerformance = lazy(
//   () => import('@components/Group/GroupPerformance')
// );
const PortfolioList = lazy(() => import('@components/Group/PortfolioList'));

/** 조합 관리 > 상세 */
const GroupDetail = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<GroupDetailInfoSkeleton />}>
          <GroupDetailInfo />
        </Suspense>
      </ApiErrorBoundary>

      <ApiErrorBoundary>
        <Suspense fallback={<GroupInvestSummarySkeleton />}>
          <GroupInvestSummary />
        </Suspense>
      </ApiErrorBoundary>

      {/* <ApiErrorBoundary>
        <Suspense fallback={<GroupPerformanceSkeleton />}>
          <GroupPerformance />
        </Suspense>
      </ApiErrorBoundary> */}

      <ApiErrorBoundary>
        <Suspense fallback={<PortfolioListSkeleton />}>
          <PortfolioList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default GroupDetail;
